import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Util } from '../../../../../../utils/util';
@Component({
	selector: 'app-pix-qr-code-dynamic-modal-msg',
	templateUrl: './modal-msg.component.html',
	styleUrls: ['./modal-msg.component.styl'],
})
export class PixQrCodeDynamicModalMsgComponent implements OnInit {

	public msg = '';
	public form: FormGroup;
	public submited = false;

	constructor(
		public dialogRef: MatDialogRef<PixQrCodeDynamicModalMsgComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private formBuilder: FormBuilder,
	) {
		this.msg = data.msg;
	}

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			msg: [this.msg, [Validators.pattern(Util.allowedCharactersRegex), Validators.maxLength(100)]],
		});
	}

	onConfirm = () => {
		this.submited = true;
		if (this.form.valid) {
			this.dialogRef.close(this.form.get('msg').value);
		}
	}

	onClose = () => this.dialogRef.close(false);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/resume-final/modal-msg/modal-msg.component.ts